import Vue from 'vue'
import { getSocketUrl } from '../utils/socket'

let ws = null,
  handles = []

//连接WebSocket
function open(token) {
  ws = new WebSocket(getSocketUrl(`/${token}`))

  ws.onmessage = (e) => {
    for(let i = 0; i < handles.length; i++){
      if(handles[i] && handles[i].callback) {
        try{
          handles[i].callback(JSON.parse(e.data))
        }catch(ex) {
          //
        }
      }
    }
  }
}

export default store => {
  Vue.prototype.$socket = {
    //打开链接
    open: () => {
      open(store.state.token.token)

      //错误重连
      ws.onerror = () => {
        setTimeout(() => {
          open(store.state.token.token)
        }, 1000)
      }
    },

    //关闭链接
    close: () => {
      handles = []
      if(ws) ws.close()
    },

    //消息监听
    message: (type, callback) => {
      if(!handles.find(item => item.type == type)) {
        handles.push({ type, callback })
      }
    },

    //移除监听
    remove(type) {
      handles = handles.filter(item => item.type != type)
    }
  }

  if(store.state.token.token) Vue.prototype.$socket.open()
}
